<template>
    <div>
        <el-dialog :title="dialogName" :visible.sync="dialogVisble" width="1200px" :before-close="hideDialogAddOrEdit"
            class="productadd" id="dialog-box" :close-on-click-modal="false">
            <el-form :model="formData" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item class="query-form-item" label="分类" prop="classifyid"
                    :rules="filter_rules({ required: true })">
                    <el-select v-model="formData.classifyParentId" placeholder="请选择一级分类" @change="selctSecond">
                        <el-option v-for="(item, index) in firstClassify" :key="index" :label="item.classifytitle"
                            :value="item.classifyid">
                        </el-option>
                    </el-select>
                    <el-select style="margin-left: 20px;" v-model="formData.classifyid" placeholder="请选择二级分类"
                        @change="secondChange">
                        <el-option v-for="(item, index) in secondClassify" :key="index" :label="item.classifytitle"
                            :value="item.classifyid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="query-form-item" label="应用场景" prop="senceId"
                    :rules="filter_rules({ required: true })">
                    <el-select v-model="formData.senceParentId" placeholder="请选择一级应用场景" @change="selctSecondSence">
                        <el-option v-for="(item, index) in firstSence" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="formData.senceId" placeholder="请选择二级应用场景" style="margin-left: 20px;"
                        @change="senceList">
                        <el-option v-for="(item, index) in secondSence" :key="index" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="序列号" prop="commoditynum"
                    :rules="filter_rules({ required: true, type: 'integer' })">
                    <el-input v-model="formData.commoditynum"></el-input>
                </el-form-item>
                <el-form-item label="商品名称" prop="commodityname" :rules="filter_rules({ required: true })">
                    <el-input v-model="formData.commodityname"></el-input>
                </el-form-item>
                <el-form-item label="图片标识" prop="commodityname" :rules="filter_rules({ required: true })">
                    <el-input v-model="formData.imgflag"></el-input>
                </el-form-item>
                <el-form-item class="query-form-item" label="品牌" prop="brandid"
                    :rules="filter_rules({ required: true })">
                    <el-select v-model="formData.brandid" placeholder="请选择品牌" style="width:150px" clearable>
                        <el-option v-for="(item,index) in comBrands" :key="index" :label="item.brandtitle"
                            :value="item.brandid"></el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="序列号" prop="commoditysort">
                    <el-input v-model="formData.commoditysort"></el-input>
                </el-form-item>-->
                <!-- <el-form-item label="缩略图" prop="commodityurl" :rules="filter_rules({ required: true })">
                    <el-upload :action="uploadUrl" ref="uploadCommodityurl" list-type="picture-card"
                     :on-success="uploadCommodityurlSuccess" accept=".png, .jpg, .jpeg"
                     :before-upload="beforeAvatarUpload" :show-file-list="false"
                     :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg','Content-Type': 'multipart/form-data'}"
                     :on-change="selectChange" :auto-upload="false"
                     :http-request="httpRequest">
                        <img v-if="formData.commodityurl" :src="formData.commodityurl" class="avatar" />
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item> -->
                <el-form-item label="封面图" prop="commodityurl" :rules="filter_rules({ required: true })">
                    <div style="display:flex; align-items: flex-end;">
                        <el-upload :action="uploadUrl" ref="uploadCommodityurl" list-type="picture-card"
                            :on-success="uploadCommodityurlSuccess" accept=".png, .jpg, .jpeg"
                            :before-upload="beforeAvatarUpload" :show-file-list="false"
                            :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}">
                            <img v-if="formData.commodityurl" :src="formData.commodityurl" class="avatar" />
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                        <span style="margin-left:10px">商品列表展示的图片，图片大小为680*540(px)</span>
                    </div>
                </el-form-item>
                <el-form-item label="轮播图">
                    <el-upload :action="uploadUrl" ref="uploadCarouselurl" list-type="picture-card"
                        :show-file-list="true" accept=".png, .jpg, .jpeg" :file-list="comCarousels"
                        :on-remove="handleRemove" :on-success="uploadSuccess" :before-upload="beforeAvatarUpload"
                        :multiple="true" :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}" :limit="6">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span style="margin-left:10px">商品详情页顶部展示的轮播图片，图片大小为680*540(px)</span>
                </el-form-item>
                <el-form-item label="材质规格">
                    <el-button type="primary" size="mini" @click="addSize">添加规格</el-button>
                    <el-card class="box-card" style="margin-top:10px;" v-for="(item, index) in formData.comSpecs"
                        :key="index">
                        <div slot="header" class="clearfix">
                            <span>规格{{ index + 1 }}</span>
                            <el-button v-if="index != 0" style="float: right; padding: 3px 0" type="text"
                                @click="delSize(index)">删除
                            </el-button>
                        </div>
                        <div class="text item">
                            <label class="labelClass">材质规格：</label>
                            <el-input v-model="item.specstand" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <label class="labelClass">工厂价：</label>
                            <el-input v-model="item.specprice" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <label class="labelClass">本地仓价格：</label>
                            <el-input v-model="item.specprom" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <br />
                            <label class="labelClass">起订量：</label>
                            <el-input v-model="item.specnum" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <label class="labelClass">重量(数字)：</label>
                            <el-input v-model="item.speclweight" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <label class="labelClass">口径：</label>
                            <el-input v-model="item.specidcaliber" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <br />
                            <label class="labelClass">外形尺寸：</label>
                            <el-input v-model="item.specsize" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="请输入内容"></el-input>
                            <label class="labelClass">有库存货期：</label>
                            <el-input v-model="item.specsurvi" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="填写货期天数"></el-input>
                            <label class="labelClass">无库存货期：</label>
                            <el-input v-model="item.specstock" size="mini" style="width:180px;margin-right:10px;"
                                placeholder="填写货期天数"></el-input>
                            <br />
                            <el-checkbox v-model="item.specdefault" @change="check($event, index)">是否默认</el-checkbox>
                        </div>
                    </el-card>
                </el-form-item>
                <el-form-item label="价格比率">
                    <el-card class="box-card">
                        <div class="text item">
                            <span>
                                <label class="labelClass">1级：</label>
                                <el-input v-model="formData.vip1" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">2级：</label>
                                <el-input v-model="formData.vip2" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">3级：</label>
                                <el-input v-model="formData.vip3" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">4级：</label>
                                <el-input v-model="formData.vip4" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">5级：</label>
                                <el-input v-model="formData.vip5" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">6级：</label>
                                <el-input v-model="formData.vip6" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">7级：</label>
                                <el-input v-model="formData.vip7" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">8级：</label>
                                <el-input v-model="formData.vip8" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">9级：</label>
                                <el-input v-model="formData.vip9" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">10级：</label>
                                <el-input v-model="formData.vip10" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">11级：</label>
                                <el-input v-model="formData.vip11" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">12级：</label>
                                <el-input v-model="formData.vip12" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">13级：</label>
                                <el-input v-model="formData.vip13" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">14级：</label>
                                <el-input v-model="formData.vip14" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">15级：</label>
                                <el-input v-model="formData.vip15" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">16级：</label>
                                <el-input v-model="formData.vip16" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">17级：</label>
                                <el-input v-model="formData.vip17" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">18级：</label>
                                <el-input v-model="formData.vip18" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">19级：</label>
                                <el-input v-model="formData.vip19" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                            <span>
                                <label class="labelClass">20级：</label>
                                <el-input v-model="formData.vip20" size="mini"
                                    style="width:80px;margin-right:10px;text-align:right;"></el-input>
                                <span>%</span>
                            </span>
                        </div>
                    </el-card>
                </el-form-item>
                <el-form-item label="规格数据" v-if="commoditySearchitemList">
                    <el-card>
                        <div class="search-list">
                            <div class="search-item" v-for="(item,index) in commoditySearchitemList" :key="index">
                                <label>{{item.name}}：</label>
                                <el-input class="search-input" v-if="item.type==1||item.type==2" v-model="item.val"
                                    size="mini" :placeholder="item.content">
                                </el-input>
                                <el-select class="search-select" v-if="item.type==3" v-model="item.val"
                                    placeholder="请选择" size="mini">
                                    <el-option v-for="itm in item.subValList" :key="itm" :label="itm" :value="itm">
                                    </el-option>
                                </el-select>
                                <el-select class="search-select" v-if="item.type==4" v-model="item.val"
                                    placeholder="请选择" size="mini">
                                    <el-option v-for="itm in item.subValList" :key="itm" :label="itm" :value="itm">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-card>
                </el-form-item>


                <el-form-item label="场景数据规格" v-if="commoditySearchitemListSence">
                    <el-card>
                        <div class="search-list">
                            <div class="search-item" v-for="(item,index) in commoditySearchitemListSence" :key="index">
                                <label>{{item.name}}：</label>
                                <el-input class="search-input" v-if="item.type==1||item.type==2" v-model="item.val"
                                    size="mini" :placeholder="item.content">
                                </el-input>
                                <el-select class="search-select" v-if="item.type==3" v-model="item.val"
                                    placeholder="请选择" size="mini">
                                    <el-option v-for="itm in item.subValList" :key="itm" :label="itm" :value="itm">
                                    </el-option>
                                </el-select>
                                <el-select class="search-select" v-if="item.type==4" v-model="item.val"
                                    placeholder="请选择" size="mini">
                                    <el-option v-for="itm in item.subValList" :key="itm" :label="itm" :value="itm">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-card>
                </el-form-item>

                <el-form-item label="商品详情" prop="commoditydetail" :rules="filter_rules({ required: true })">
                    <Tinymce ref="tinymce" v-model="formData.commoditydetail"></Tinymce>
                </el-form-item>
                <el-form-item label="相关文档" prop="commoditydetail">
                    <el-upload :action="fileuploadUrl" :on-remove="handleRemoveFile" :before-remove="beforeRemove"
                        :on-success="upfilesuccess" multiple :file-list="fileList" accept=".doc, .docx, .pdf"
                        :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="置换数据">
                    <el-card class="box-card">
                        <!-- 制造商 -->
                        <div class="text item" v-for="(item,index) in hfUnitReplacementList" :key="index">
                            <label>{{item.cn}}：</label>
                            <el-input size="mini" v-model="item.en" class="zhihuan-input"></el-input>
                            <el-button size="mini" type="primary" @click="addZhihuan(index)">添加</el-button>
                            <div class="mt">
                                <el-tag class="tagStyle" v-for="(itm,idx) in item.name" :key="idx" closable
                                    @close="rmoveZhihuan(index,idx)">
                                    {{itm}}
                                </el-tag>
                            </div>
                        </div>
                    </el-card>
                </el-form-item>
                <!-- 新加的开始 -->
                <el-form-item label="国家数据">
                    <el-card class="box-card">
                        <div>
                            <el-checkbox v-for="(item, index) in countrylist" :key="item.id" v-model="item.checked">
                                {{item.name}}
                            </el-checkbox>
                        </div>
                    </el-card>
                </el-form-item>
                <!-- 新加的结束 -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="hideDialogAddOrEdit">取 消</el-button>
                <el-button type="primary" :loading="formSumbitLoding" @click="formSumbit">提交</el-button>
            </span>
        </el-dialog>
        <!-- vueCropper 剪裁图片实现-->
        <cropper v-if="showCropper" :dialog-visible="showCropper" :cropper-img="cropperImg"
            @update-cropper="updateCropper" @colse-dialog="closeDialog" @upload-img="uploadImg" />
    </div>
</template>
<script>
    import {
        getClassify,
        getClassifyTwo,
        firstSence,
        secondSence,
        getSerchItem,
        updateCommodity,
        CommodityInfo,
        getSenceItem
    } from "../../api/product/product";
    import Tinymce from "@/components/Tinymce/index";
    import {
        BASE_URL
    } from "../../config/app";
    import axios from "axios";
    import Cropper from "./cropper.vue";
    /*用作表单的数据初始化*/
    export default {
        components: {
            Tinymce,
            Cropper,
        },

        data() {
            return {
                countrylist: JSON.parse(sessionStorage.getItem('opencountry')),
                uploadUrl: BASE_URL + "/upload/tool/uploadpro", //图片上传路径
                fileuploadUrl: BASE_URL + "/upload/tool/uploadFile", //文件上传路径
                formSumbitLoding: false, //表单提交加载
                dialogVisble: false, //弹框开关
                dialogName: "", //新增或编辑弹框名字
                id: "",
                formData: {
                    commodityid: "", //商品id
                    classifyParentId: "", //一级分类id
                    classifyid: "", //二级分类id
                    senceParentId: "", //一级场景id
                    senceId: "", //二级场景id
                    commodityname: "", //商品名称
                    commoditynum: "", //商品编码
                    commoditydetail: "", //商品详情
                    commodityurl: "", //缩略图
                    comCarousels: [], //轮播图
                    commoditySearchitemList: [], //规格数据
                    hfCommodityAccessories: [], //附件数据
                    hfUnitReplacementList: [], //置换数据
                    commoditySearchitemListSence: [], //场景
                    comSpecs: [{
                        specstand: "", //材质规格
                        specprice: "", //价格 工厂价
                        specprom: "", //促销价格 本地仓价格
                        specnum: "", //起订量
                        speclweight: "", //重量
                        specidcaliber: "", //口径
                        specsize: "", //外形尺寸
                        specsurvi: "", //有库存货期
                        specstock: "", //无库存货期
                        specdefault: true, //是否默认 0、不默认 1、默认
                    }, ], //规格数组
                    vip1: "",
                    vip2: "",
                    vip3: "",
                    vip4: "",
                    vip5: "",
                    vip6: "",
                    vip7: "",
                    vip8: "",
                    vip9: "",
                    vip10: "",
                    vip11: "",
                    vip12: "",
                    vip13: "",
                    vip14: "",
                    vip15: "",
                    vip16: "",
                    vip17: "",
                    vip18: "",
                    vip19: "",
                    vip20: "",
                }, //新增或修改的对象
                hfUnitReplacementList: [{
                    cn: "制造商",
                    en: "",
                    type: 1,
                    name: []
                }, {
                    cn: "型号",
                    en: "",
                    type: 2,
                    name: []
                }, {
                    cn: "板数",
                    en: "",
                    type: 3,
                    name: []
                }, {
                    cn: "应用",
                    en: "",
                    type: 4,
                    name: []
                }], //置换数据
                firstClassify: [], //一级分类
                secondClassify: [], //二级分类
                firstSence: [], //一级场景
                secondSence: [], //二级场景
                comCarousels: [], //轮播图合集
                fileList: [], //文件合集
                commoditySearchitemList: [], // 搜索项
                commoditySearchitemListSence: [], //场景
                cropperImg: "", // 需要裁剪的图片
                showCropper: false, // 是否显示裁剪框
                uploadFile: "",
                currentFile: "",
                action: "",
                comBrands: [],
            };
        },

        methods: {
            // 选择文件
            selectChange(file) {
                console.log("0000", file);
                const {
                    raw
                } = file;
                this.openCropper(raw);
            },
            openCropper(file) {
                var files = file;
                let isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                if (!isJPG) {
                    this.$message.error("上图片只能是 JPG/PNG 格式!");
                    return false;
                }
                var reader = new FileReader();
                reader.onload = (e) => {
                    let data;
                    console.log(typeof e.target.result);
                    console.log(e.target.result);
                    if (typeof e.target.result === "object") {
                        // 把Array Buffer转化为blob 如果是base64不需要
                        data = window.URL.createObjectURL(
                            new Blob([e.target.result])
                        );
                    } else {
                        data = e.target.result;
                    }
                    this.cropperImg = data;
                    // 图片图片尺寸，如果是正方形，则直接上传；否则调用裁剪
                    let img = new Image();
                    img.src = this.cropperImg;
                    img.onload = () => {
                        if (img.width == img.height) {
                            // 本来就是正方形 => 直接上传
                            this.uploadFile = files;
                            this.$refs.uploadCommodityurl.submit();
                        } else {
                            this.showCropper = true; // 不是正方形的图片才开启裁剪
                            this.currentFile = file; // 保存当前操作裁剪的图片
                        }
                    };
                };
                // 转化为base64
                // reader.readAsDataURL(file)
                // 转化为blob
                reader.readAsArrayBuffer(files);
            },
            // 上传图片
            uploadImg(file) {
                this.showCropper = false;
                this.uploadFile = file;
                this.$refs.uploadCommodityurl.submit();
            },
            // 更新图片
            updateCropper() {
                this.$refs.uploadCommodityurl.$children[0].$el.click();
            },
            // 关闭窗口
            closeDialog() {
                this.showCropper = false;
            },
            // 裁剪确认之后会触发此方法
            httpRequest(request) {
                //const { action, data, filename } = request;
                console.log(request);
                let formData = new FormData();
                //formData.append('file',this.uploadFile);
                formData.append("file", request.file);
                axios.post(request.action, formData).then((res) => {
                    console.log("res=>", res);
                });
            },
            // 移除文档
            handleRemoveFile(file, fileList) {
                let data = this.formData.hfCommodityAccessories;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].url == file.url) {
                        data.splice(i, 1);
                    }
                }
                this.formData.hfCommodityAccessories = data;
            },
            // 上传成功
            upfilesuccess(res, file) {
                if (res.data) {
                    this.formData.hfCommodityAccessories.push({
                        name: file.name,
                        url: file.response.data,
                    });
                }
            },
            // 移除文档前
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            /*新增或者编辑提交事件*/
            formSumbit() {

                this.formData.comSpecs.forEach((item) => {
                    if (item.specdefault == false) {
                        item.specdefault = 0;
                    } else {
                        item.specdefault = 1;
                    }
                });
                this.formData.commoditySearchitemList = [];
                this.commoditySearchitemList.forEach((item) => {
                    this.formData.commoditySearchitemList.push({
                        searchitemId: item.id,
                        typeVal: item.val,
                    });
                });
                this.formData.commoditySearchitemListSence = [];
                this.commoditySearchitemListSence.forEach((item) => {
                    this.formData.commoditySearchitemListSence.push({
                        searchitemId: item.id,
                        typeVal: item.val,
                    });
                });

                this.formData.hfUnitReplacementList = [];
                this.hfUnitReplacementList.forEach((item) => {
                    if (item.type != "" || item.name.length > 0) {
                        this.formData.hfUnitReplacementList.push({
                            type: item.type,
                            name: item.name,
                        });
                    }
                });

                this.formData.countryIdList = [];
                this.countrylist.forEach(item => {
                    if (item.checked == true) {
                        this.formData.countryIdList.push(item.id);
                    }
                })
                //console.log("提交表单", this.formData);
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        updateCommodity(this.formData)
                            .then((response) => {
                                console.log(response);
                                if (response.code != 0) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.hideDialogAddOrEdit();
                                this.$message.success("提交成功");
                                this.formSumbitLoding = false;
                                this.$emit("getList");
                            })
                            .catch(() => {
                                this.$message.error("提交出错");
                                this.formSumbitLoding = false;
                            });
                    }
                });
            },

            /*是否默认选择事件*/
            check(event, index) {
                if (event == true) {
                    this.formData.comSpecs[index].specdefault = true;
                    for (var i = 0; i < this.formData.comSpecs.length; i++) {
                        if (i != index) {
                            this.formData.comSpecs[i].specdefault = false;
                        }
                    }
                }
            },

            /*添加规格*/
            addSize() {
                this.formData.comSpecs.push({
                    specstand: "", //材质规格
                    specprice: "", //价格 工厂价
                    specprom: "", //促销价格 本地仓价格
                    specnum: "", //起订量
                    speclweight: "", //重量
                    specidcaliber: "", //口径
                    specsize: "", //外形尺寸
                    specsurvi: "", //有库存货期
                    specstock: "", //无库存货期
                    specdefault: false, //是否默认
                });
            },
            /*删除规格*/
            delSize(index) {
                this.formData.comSpecs.splice(index, 1);
            },
            /*缩略图*/
            uploadCommodityurlSuccess(response) {
                let url = response.data;
                this.formData.commodityurl = url;
            },
            /*轮播图删除*/
            handleRemove(file) {
                for (var i = 0; i < this.formData.comCarousels.length; i++) {
                    if (this.formData.comCarousels[i] == file.url) {
                        this.formData.comCarousels.splice(i, 1);
                    }
                }
            },
            /*轮播图上传*/
            uploadSuccess(res) {
                this.formData.comCarousels.push(res.data);
            },
            /*图片上传之前操作（限制类型大小）*/
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error("上图片只能是 JPG/PNG 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                    return false;
                }
                let imgWidth = "";
                let imgHight = "";
                const isSize = new Promise(function (resolve, reject) {
                    let width = 680;
                    let height = 540;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        imgWidth = img.width;
                        imgHight = img.height;
                        let valid = img.width == width && img.height == height;
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                }).then(() => {
                    return file;
                }, () => {
                    this.$message.error("图片尺寸需为680 x 540px。当前上传图片的尺寸为：" + imgWidth + "x" + imgHight + "px");
                    return Promise.reject();
                    return false;
                });
                return isJPG && isLt2M && isSize;
            },

            /*查询一级分类*/
            getClassify() {
                getClassify()
                    .then((response) => {
                        // if (response.code != 0) {
                        //     this.$message.error(response.message);
                        // }
                        this.firstClassify = response.data || [];
                    })
                    .catch(() => {
                        this.$message.error("查询分类出差!");
                    });
            },
            /*选择一级分类查询二级分类*/
            selctSecond() {
                this.secondClassify = [];
                this.formData.classifyid = "";
                let params = {
                    comClassifyParentId: this.formData.classifyParentId,
                };
                getClassifyTwo(params).then((response) => {
                    if (response.data.length > 0) {
                        this.secondClassify = response.data;
                        this.formData.classifyid =
                            this.secondClassify[0].classifyid;
                        this.getSerchItem();
                    }
                });
            },
            //选择二级分类查询搜索项
            secondChange() {
                this.getSerchItem();
            },
            getSerchItem() {
                let params = {
                    classifyId: this.formData.classifyid,
                };
                getSerchItem(params).then((res) => {
                    console.log('搜索项', res.data)
                    this.commoditySearchitemList = res.data;
                });
            },
            //选择二级分类场景
            senceList() {
                this.getSenceV();
            },
            getSenceV() {
                let params = {
                    senceId: this.formData.senceId,
                };
                getSenceItem(params).then((res) => {
                    //console.log('搜索项',res.data)
                    this.commoditySearchitemListSence = res.data;
                });
            },


            /*选择一级场景查询二级场景*/
            selctSecondSence() {
                this.secondSence = [];
                this.formData.senceId = "";
                let params = {
                    henseParentId: this.formData.senceParentId,
                };
                secondSence(params).then((response) => {
                    if (response.data.length > 0) {
                        this.secondSence = response.data;
                        this.formData.senceId = this.secondSence[0].id;
                        this.getSenceV();
                    }
                });
            },
            /*查询一级场景*/
            getSence() {
                firstSence().then((res) => {
                    if (res.code != 0) {
                        this.$message.error(res.message);
                    }
                    this.firstSence = res.data || [];
                });
            },
            /*显示 -新增或者编辑弹框*/
            openDialog(id, comBrands) {
                this.dialogVisble = true;
                console.log("conBrands=", comBrands);
                this.comBrands = comBrands;
                if (id !== null) {
                    this.getDetail(id);
                    //如果id不为空，说明是修改
                    this.dialogName = "编辑";
                } else {
                    this.dialogName = "新增";
                }
            },
            //获取详情
            getDetail(id) {
                CommodityInfo({
                        commodityid: id
                    })
                    .then((res) => {
                        // //规格数据
                        if (res.data.comSpecs != null && res.data.comSpecs.length > 0) {
                            for (var i = 0; i < res.data.comSpecs.length; i++) {
                                if (res.data.comSpecs[i].specdefault == 1) {
                                    res.data.comSpecs[i].specdefault = true;
                                } else {
                                    res.data.specdefault = false;
                                }
                            }
                        }
                        //商品详情
                        let vm = this;
                        setTimeout(function () {
                            vm.$nextTick(() => {
                                if (vm.$refs.tinymce) {
                                    vm.$refs.tinymce.setContent(
                                        res.data.commoditydetail
                                    );
                                }
                            });
                        }, 500);

                        //轮播图
                        let comCarousels = [],
                            fileList = [];
                        if (res.data.comCarousels != null && res.data.comCarousels.length > 0) {
                            res.data.comCarousels.forEach((item) => {
                                this.comCarousels.push({
                                    url: item.carouselurl
                                });
                                comCarousels.push(item.carouselurl);
                            });
                        }
                        //相关文件
                        if (
                            res.data.hfCommodityAccessories != null &&res.data.hfCommodityAccessories.length > 0) {
                            this.fileList = res.data.hfCommodityAccessories;
                            res.data.hfCommodityAccessories.forEach((item) => {
                                fileList.push({
                                    name: item.name,
                                    url: item.url
                                });
                            });
                        }
                        //国家列表
                        if (res.data.mbCountryList.length > 0) {
                            this.countrylist.forEach(item => {
                                res.data.mbCountryList.forEach(itm => {
                                    if (item.id == itm.id) {
                                        item.checked = true
                                    }
                                })
                            })
                        }
                        this.formData = res.data;
                        this.formData.hfCommodityAccessories = fileList;
                        this.formData.comCarousels = comCarousels;
                        if (this.formData.classifyParentId) {
                            this.getSecondclass(); //获取二级分类
                        }

                        this.getSecondSence(); //获取二级场景
                        //查询搜索项//
                        let params = {
                            classifyId: res.data.classifyid
                        };
                        getSerchItem(params).then((ress) => {
                            this.commoditySearchitemList = ress.data;
                            this.commoditySearchitemList.forEach((item) => {
                                res.data.commoditySearchitemList.forEach((itm) => {
                                    if (item.id == itm.searchitemId) {
                                        item.val = itm.typeVal;
                                    }
                                });
                            });
                        });

                        //查询场景//
                        let paramss = {
                            senceId: this.formData.senceId,
                        };
                        getSenceItem(paramss).then((ress) => {
                            this.commoditySearchitemListSence = ress.data;
                            this.commoditySearchitemListSence.forEach((item) => {
                                res.data.commoditySearchitemListSence.forEach((itm) => {
                                    if (item.id == itm.searchitemId) {
                                        item.val = itm.typeVal;
                                    }
                                });
                            });
                        });

                        //置换数据
                        this.hfUnitReplacementList.forEach(item => {
                            res.data.hfUnitReplacementList.forEach(itm => {
                                if (item.type == itm.type) {
                                    item.name.push(itm.name)
                                }
                            })
                        })
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            },
            /*查询二级分类*/
            getSecondclass() {
                let params = {
                    comClassifyParentId: this.formData.classifyParentId,
                };
                getClassifyTwo(params).then((response) => {
                    if (response.data.length > 0) {
                        this.secondClassify = response.data;
                    }
                });
            },
            /*查询二级场景*/
            getSecondSence() {
                let params = {
                    henseParentId: this.formData.senceParentId,
                };
                secondSence(params).then((response) => {
                    if (response.data.length > 0) {
                        this.secondSence = response.data;
                    }
                });
            },

            /*隐藏 -新增或编辑弹框*/
            hideDialogAddOrEdit() {
                Object.assign(this.formData, this.$options.data().formData);
                this.hfUnitReplacementList = this.$options.data().hfUnitReplacementList;
                this.dialogVisble = false;
                this.comCarousels = []; //清除轮播图列表绑定值
                this.fileList = []; //文件合集
                this.commoditySearchitemList = []; // 搜索项
                this.commoditySearchitemListSence = []; //场景
                this.countrylist.forEach(item => {
                    item.checked = false
                })
                if (this.$refs["tinymce"]) {
                    this.$refs.tinymce.clearContent();
                }
            },
            //新增置换数据
            addZhihuan(index) {
                var value = this.hfUnitReplacementList[index].en;
                if (value == "") return
                this.hfUnitReplacementList[index].name.push(value)
                this.hfUnitReplacementList[index].en = ""
            },
            //移除置换数据
            rmoveZhihuan(index, idx) {
                this.hfUnitReplacementList[index].name.splice(idx, 1)
            },
        },

        filters: {
            price: function (myInput) {
                var val = parseInt(myInput);
                if (typeof val === "number") {
                    return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                }
            },
        },

        created() {
            this.getClassify(); //查询分类
            this.getSence(); //查询一级场景
        }
    };

</script>

<style lang="scss" scoped>
    .labelClass {
        display: inline-block;
        width: 90px;
        text-align: right;
    }

    .labelMini {
        display: inline-block;
        width: 50px;
        text-align: right;
    }

    .showContent {
        display: inline-block;
        width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
    }

    .search-list {
        display: flex;
        width: 100%;
        flex-wrap: wrap;

        .search-item {
            width: 33%;
        }

        .search-input {
            width: 150px;
        }

        .search-select {
            width: 120px;
        }
    }

    .zhihuan-input {
        width: 200px;
        margin-right: 15px;
    }

    .textBox {
        display: inline-block;
        max-width: 830px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
    }

    .avatar {
        width: 100%;
        height: 100%;
    }

    .el-dialog>.el-dialog__footer>.dialog-footer>.pagination-container {
        margin: 10px;
        float: none;
    }

    .aaa img {
        display: block;
        max-width: 100%;
        height: auto !important;
        margin-bottom: 10px;
        box-shadow: 0 0 7px 1px #eee;
    }

    .productadd .el-dialog {
        margin-top: 2vh !important;
    }

    .cropper-box {
        width: auto;
        height: 300px;
    }

    .mt {
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .tagStyle {
        margin-right: 10px;
        height: 32px;
        padding: 0 10px;
        line-height: 30px;
        margin-bottom: 5px;
    }

</style>
